import { render, staticRenderFns } from "./TeacherClassrooms.vue?vue&type=template&id=fa3aac48&"
import script from "./TeacherClassrooms.vue?vue&type=script&lang=js&"
export * from "./TeacherClassrooms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports